module.exports = __webpack_public_path__ + "img/next-arrow-red.0803971e.svg";